import { SELL_API as axios } from '@services/axiosInstance';
import type { CustomerInfoRequest, CustomerInfoResponse, CustomerMetadata } from '@t/checkout.types';

// =============================================================================
// Customer Metadata
// =============================================================================

// TODO: Remove mock fallback once BE /cpq/v1/metadata endpoint is stable
const MOCK_METADATA: CustomerMetadata = {
  phoneProviders: [
    { phoneProviderId: 71800, name: 'Sprint' },
    { phoneProviderId: 71801, name: 'AT&T' },
    { phoneProviderId: 71802, name: 'Verizon' },
  ],
  directoryListings: [
    { directoryListingId: 2445, name: 'Listed' },
    { directoryListingId: 2446, name: 'Non-Listed' },
    { directoryListingId: 2447, name: 'Non-Published' },
  ],
  phoneNumberTypes: [
    { phoneNumberTypeId: 116, name: 'Home phone' },
    { phoneNumberTypeId: 117, name: 'Cell phone' },
    { phoneNumberTypeId: 118, name: 'Work phone' },
  ],
  titles: [
    { titleId: 10297, name: 'Mr.' },
    { titleId: 10298, name: 'Mrs.' },
    { titleId: 10299, name: 'Ms.' },
    { titleId: 10300, name: 'Dr.' },
  ],
  salesReps: [
    { salesRepId: 123, code: '01S', name: 'Catherine Peterson' },
    { salesRepId: 124, code: '02S', name: 'James Rodriguez' },
  ],
  passwordRequirements: {
    minLength: 4,
    maxLength: -1,
    lowercase: 0,
    uppercase: 1,
    digit: 1,
    special: 0,
  },
  cardTypes: [
    { cardTypeId: 69, name: 'Mastercard' },
    { cardTypeId: 70, name: 'Visa' },
    { cardTypeId: 71, name: 'American Express' },
  ],
  discountTypes: [
    { discountTypeId: 3562, code: 'CPN', name: 'Coupons' },
    { discountTypeId: 3561, code: 'PRM', name: 'Promotional' },
  ],
  wireTypes: [
    { wireTypeId: 3111, name: 'Landline' },
    { wireTypeId: 3110, name: 'Wireless' },
  ],
};

export const getCustomerMetadata = async (): Promise<CustomerMetadata> => {
  try {
    const { data } = await axios.get<CustomerMetadata>('/metadata');
    return data;
  } catch {
    console.warn('[checkoutService] GET /metadata failed, using mock data');
    return MOCK_METADATA;
  }
};

// =============================================================================
// Customer Info
// =============================================================================

export const getCustomerInfo = async (sessionId: string): Promise<CustomerInfoResponse> => {
  const { data } = await axios.get<CustomerInfoResponse>(`/sessions/${sessionId}/customerInfo`);
  return data;
};

export const saveCustomerInfo = async (
  sessionId: string,
  payload: CustomerInfoRequest
): Promise<CustomerInfoResponse> => {
  const { data } = await axios.post<CustomerInfoResponse>(`/sessions/${sessionId}/customerInfo`, payload);
  return data;
};

export const updateCustomerInfo = async (
  sessionId: string,
  payload: CustomerInfoRequest
): Promise<CustomerInfoResponse> => {
  const { data } = await axios.put<CustomerInfoResponse>(`/sessions/${sessionId}/customerInfo`, payload);
  return data;
};
